import { render, staticRenderFns } from "./CostElement.vue?vue&type=template&id=0871a69c&scoped=true"
import script from "./CostElement.vue?vue&type=script&lang=js"
export * from "./CostElement.vue?vue&type=script&lang=js"
import style0 from "./CostElement.vue?vue&type=style&index=0&id=0871a69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871a69c",
  null
  
)

export default component.exports